import React, { useEffect, useRef, useState } from "react";
import {
    Card,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    TableBody,
    CircularProgress,
    Grid,
    Paper,
} from "@mui/material";
import axios from "axios";

interface TableData {
    id_wo: string;
    target: string;
    kesiapan: string;
    realisasi: string;
    packing: string;
}

export default function DashboardCardTableAutoScroll() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TableData[]>([]);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const scrollDirection = useRef<"down" | "up">("down");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // contoh dummy data
                const dummy: TableData[] = Array.from({ length: 40 }).map((_, i) => ({
                    id_wo: `WO-${1000 + i}`,
                    target: `${Math.floor(Math.random() * 1000)} pcs`,
                    kesiapan: `${Math.floor(Math.random() * 100)}%`,
                    realisasi: `${Math.floor(Math.random() * 100)}%`,
                    packing: `${Math.floor(Math.random() * 50)} box`,
                }));
                setData(dummy);

                // kalau mau pakai API tinggal ganti ini:
                // const res = await axios.get("URL_API");
                // setData(res.data.data);

            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // auto-scroll effect
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const scrollSpeed = 0.5; // kecepatan scroll
        const interval = setInterval(() => {
            if (scrollDirection.current === "down") {
                container.scrollTop += scrollSpeed;
                if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                    scrollDirection.current = "up";
                }
            } else {
                container.scrollTop -= scrollSpeed;
                if (container.scrollTop <= 0) {
                    scrollDirection.current = "down";
                }
            }
        }, 20); // semakin kecil semakin halus

        return () => clearInterval(interval);
    }, [data]);

    return (
        <Card
            sx={{
                height: "calc(100vh - 364px)", // ⬅️ sesuaikan 250px ini dengan tinggi header + chart area di atasnya
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {loading ? (
                <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
                >
                    <CircularProgress disableShrink />
                </Grid>
            ) : (
                <TableContainer
                    component={Paper}
                    ref={containerRef}
                    sx={{
                        flex: 1,
                        borderRadius: 0,
                        overflowY: "auto",
                        scrollBehavior: "smooth",
                    }}
                >
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    ID WO
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Target
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Kesiapan Produksi
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Realisasi Produksi
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Packing
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell align="center">{row.id_wo}</TableCell>
                                    <TableCell align="center">{row.target}</TableCell>
                                    <TableCell align="center">{row.kesiapan}</TableCell>
                                    <TableCell align="center">{row.realisasi}</TableCell>
                                    <TableCell align="center">{row.packing}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Card>
    );
}
